(() => {
  const BROCHURE_VARIANT_ID = 56333531414860;

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return res.json();
  }

  async function addBrochure() {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: BROCHURE_VARIANT_ID, quantity: 1 }),
      credentials: 'same-origin'
    });
  }

  async function removeBrochure() {
    const cart = await fetchCart();
    const item = cart.items.find(i => i.variant_id === BROCHURE_VARIANT_ID);
    if (!item) return;

    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 0 }),
      credentials: 'same-origin'
    });
  }

  function bindCheckbox(root = document) {
    const checkbox = root.querySelector('#brochure-checkbox');
    if (!checkbox) return;

    // verhindert doppelte Listener beim Rebind
    if (checkbox.dataset.brochureBound === '1') return;
    checkbox.dataset.brochureBound = '1';

    checkbox.addEventListener('change', async () => {
      checkbox.disabled = true;
      try {
        if (checkbox.checked) {
          await addBrochure();
        } else {
          await removeBrochure();
        }

        // Theme-agnostischer Refresh-Trigger:
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        // Fallback, falls das Theme nicht darauf hört:
        // (Concept rendert den Drawer oft via Sections neu – falls das bei dir nicht greift,
        // kannst du hier hart refreshen)
        // window.location.reload();
      } finally {
        checkbox.disabled = false;
      }
    });
  }

  // Initial
  document.addEventListener('DOMContentLoaded', () => bindCheckbox());

  // Rebind bei typischen Cart/Drawer Updates
  document.addEventListener('cart:refresh', () => bindCheckbox());
  document.addEventListener('cart:updated', () => bindCheckbox());
  document.addEventListener('drawer:open', () => bindCheckbox());

  // Rebind wenn der Drawer DOM ersetzt wird (AJAX/sections rendering)
  const obs = new MutationObserver(() => bindCheckbox());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
